import React from 'react';

import { PlayerContext } from './PlayerContext';

export const usePlayerContext = () => React.useContext(PlayerContext);
